/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const ExpandedPopup = styled.div`
  width: 384px;
  max-height: 400px;
  overflow-y: auto;
  position: sticky;
  box-shadow: ${token(
    'elevation.shadow.overlay',
    '-30px 30px 48px rgba(0, 0, 0, 0.15)'
  )};
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const TopHeaderSection = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  height: 36px;
  padding-left: 16px;
  top: 0;
  border: 0.5px solid ${token('color.border', colors.N40)};
  background: ${token('color.background.input', colors.N0)};
  z-index: 185;
  text-transform: uppercase;
  color: ${token('color.text.subtlest', colors.N200)};
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
`;

export const BottomHeaderSection = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  height: 36px;
  padding-left: 16px;
  top: 36px;
  bottom: 0;
  border: 0.5px solid ${token('color.border', colors.N40)};
  background: ${token('color.background.input', colors.N0)};
  z-index: 185;
  text-transform: uppercase;
  color: ${token('color.text.subtlest', colors.N200)};
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
`;

export const CommentPreview = styled.div`
  box-sizing: border-box;
  height: 84px;
  border: 0.5px solid ${token('color.border', colors.N40)};
  padding: 16px 18px;
  gap: 8px;
  position: sticky;
  z-index: 184;
  overflow: clip;
  cursor: pointer;

  &:hover,
  &:focus {
    background-color: ${token(
      'color.background.accent.gray.subtlest',
      colors.N20
    )};
  }

  &:active {
    background-color: ${token('color.background.selected', colors.B50)};
  }
`;

export const EmptyCommentSection = styled.div`
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-weight: 700;
  border: 0.5px solid ${token('color.border', colors.N40)};
`;

export const CommentPreviewHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const MetadataAndAvatar = styled.div`
  display: flex;
  gap: 6px;
  flex-grow: 1;
`;

export const CommentMetadata = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const FileDateDescription = styled.div`
  display: flex;
  font-size: 11px;
  font-weight: 400;
  color: ${token('color.text.subtlest', colors.N200)};

  > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 305px;
  }
`;

export const UsernameAndOutdatedLozenge = styled.div<{
  commentIsOutdated: boolean;
}>`
  justify-content: space-between;
  display: flex;
  align-items: center;

  > span:first-child {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: ${props => (props.commentIsOutdated ? '242px' : '305px')};
  }
`;

export const CollapseExpandButton = styled.button`
  background: none;
  border: none;
  color: inherit;
  font: inherit;
  margin-left: auto;
`;

export const NoPreviewAvailable = styled.div`
  color: ${token('color.text.subtlest', colors.N200)};
  font-style: italic;
`;

export const PreviewText = styled.div`
  line-height: 1.5rem;
`;
